import { format } from "date-fns";
import React, { useEffect, useRef } from "react";
import { InamdarHospiLogo } from "../../../assets/printAssets/InmadarHospiLogo";
import RadioNABHLogo from "../../../assets/icons/RadioNABHLogo";
import html2pdf from "html2pdf.js";

const modifiedTemplateDescription = (htmlContent) => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlContent, "text/html");
  const pTagsInsideLists = doc.querySelectorAll("ul p, ol p, li p");
  pTagsInsideLists.forEach((p) => {
    const span = document.createElement("span");
    span.innerHTML = p.innerHTML;
    p.parentNode.replaceChild(span, p);
  });
  return doc.body.innerHTML;
};

export default function DownloadRadiologyWOPrint(props) {
  const { selectedRow, dataResult, images } = props;

  const printRef = useRef(null); // Ref to the content that will be converted to PDF

  // Modify template description (if needed) for PDF content
  const modifiedHtml = modifiedTemplateDescription(
    dataResult?.TemplateDescription
  );

  // Automatically download PDF when the component is ready
  useEffect(() => {
    if (dataResult && modifiedHtml) {
      // Ensure the image is properly set up (if any)
      let imageId = document.getElementById("imageId");

      if (imageId && images && images.length > 0) {
        // Find the correct image based on OrderDtlsId
        imageId.src =
          images.find((image) => image?.orderDtlsId === dataResult?.OrderDtlsId)
            ?.base64 || "";
      }

      // Download PDF after everything is set up
      setTimeout(() => {
        // Trigger PDF download
        DownloadPrintForLIMS(printRef);
      }, 500); // Delay to ensure content is ready
    }
  }, [dataResult, images]);

  // Simplified download function using html2pdf.js
  const DownloadPrintForLIMS = (contentRef) => {
    const clonedContent = contentRef?.current;
    console.log("download Print", clonedContent);

    // Check if content is empty
    const isBlank =
      clonedContent?.innerText?.trim() === "" &&
      clonedContent?.innerHTML?.trim() === "";
    if (isBlank) {
      alert("Nothing to print. The content is empty.");
      return;
    }

    // Set PDF options
    const options = {
      margin: [0.1, 0.5, 0.3, 0.5], // Top and left margins in inches
      filename: "Radiology_Report.pdf", // Default PDF filename
      image: { type: "jpeg", quality: 0.98 }, // Image quality
      html2canvas: { scale: 2 }, // Canvas rendering quality
      jsPDF: { unit: "in", format: "A4", orientation: "portrait" }, // PDF format and orientation
    };

    // Call html2pdf to generate and download the PDF
    html2pdf()
      .from(clonedContent) // The source HTML element
      .set(options) // Set options
      .toPdf() // Generate PDF
      .get("pdf") // Get PDF instance
      .then(function (pdf) {
        pdf.save("Radiology_Report.pdf"); // Trigger PDF download
      })
      .catch(function (err) {
        console.error("Error generating PDF:", err);
        alert("An error occurred while generating the PDF.");
      });
  };
  console.log("printRef", printRef);

  return (
    <div className="printBody" ref={printRef}>
      <table
        style={{ "-fs-table-paginate": "paginate !important" }}
        className="w-full"
      >
        <thead className="w-full">
          <tr>
            <th colSpan="3" className="flex items-center text-center h-20">
              <div className="flex justify-start w-14">
                <RadioNABHLogo />
              </div>
              <div className="text-center w-full">
                <h1 className="text-[12px] font-semibold">
CIMET's Inamdar Multispeciality Hospital                   </h1>
                <h1 className="text-[12px] font-semibold">
                  Sr. No 15, Fatimanagar, Behind Kpct Mall Pune - 411 040
                </h1>
                <h1 className="text-[12px] font-semibold">
                  Phone No : 020-66812222/44
                </h1>
              </div>
              <div className="flex justify-end w-24">
                <InamdarHospiLogo />
              </div>
            </th>
          </tr>
          <tr>
            <th colSpan="3" className="text-left">
              <hr className="border-t-[1px] border-black -mb-2" />
              <div className="grid grid-cols-2">
                <div className="flex items-center">
                  <div className="text-[12px] font-semibold w-16">Date</div>
                  <div className="text-[12px]">:&nbsp;{dataResult?.Date}</div>
                </div>
                <div className="flex items-center">
                  <div className="text-[12px] font-semibold w-32">
                    Report Date & Time
                  </div>
                  <div className="text-[12px]">
                    :&nbsp;{dataResult?.ReportDate} {dataResult?.ReportTime}
                  </div>
                </div>
                <div className="flex items-center">
                  <div className="text-[12px] font-semibold w-16">UHID</div>
                  <div className="text-[12px]">:&nbsp;{dataResult?.MRNo}</div>
                </div>
                <div className="flex items-center">
                  <div className="text-[12px] font-semibold w-32">
                    Printed Date & Time
                  </div>
                  <div className="text-[12px]">
                    :&nbsp;{format(new Date(), "dd/MM/yyyy hh:mm aa")}
                  </div>
                </div>
                <div className="flex items-center">
                  <div className="text-[12px] font-semibold w-16">Name</div>
                  <div className="text-[12px]">
                    :&nbsp;{dataResult?.PatientName}
                  </div>
                </div>
                <div className="flex items-center">
                  <div className="text-[12px] font-semibold w-32">
                    Consultant
                  </div>
                  <div className="text-[12px]">
                    :&nbsp;{dataResult?.Consultant}
                  </div>
                </div>
                <div className="flex items-center">
                  <div className="text-[12px] font-semibold w-16">
                    Age / Sex
                  </div>
                  <div className="text-[12px]">
                    :&nbsp;
                    {`${dataResult?.AgeYear} Y, ${dataResult?.AgeMonth} M, ${dataResult?.AgeDay} D / ${dataResult?.Gender}`}
                  </div>
                </div>
                <div className="flex items-center">
                  <div className="text-[12px] font-semibold w-32">
                    Advised By
                  </div>
                  <div className="text-[12px]">
                    :&nbsp;{dataResult?.AdvisedBy || ""}
                  </div>
                </div>
                <div className="flex items-center">
                  <div className="text-[12px] font-semibold w-16">Bed No</div>
                  <div className="text-[12px]">:&nbsp;{dataResult?.BedNo}</div>
                </div>
                <div className="flex items-center">
                  <div className="text-[12px] font-semibold w-32">Ward</div>
                  <div className="text-[12px]">:&nbsp;{dataResult?.Ward}</div>
                </div>
              </div>
            </th>
          </tr>
          {!selectedRow?.IsCompleted && (
            <tr>
              <th colSpan="3" className="text-[15px]">
                <hr className="border-t-[1px] border-black mt-1 -mb-3" />
                <div className="text-customRed ">Provisional Report</div>
              </th>
            </tr>
          )}
          <tr>
            <th colSpan="3" className="space-y-1">
              <hr className="border-t-[1px] border-black mt-1 -mb-3" />
              <div className="font-semibold -ml-14 flex justify-center">
                {dataResult?.TestName}
              </div>
              <hr className="border-t-[1px] border-black mt-1" />
            </th>
          </tr>
        </thead>

        <tbody className="w-full">
          <tr>
            <td colSpan="3" className="">
              <div
                className="w-full"
                dangerouslySetInnerHTML={{
                  __html: modifiedHtml,
                }}
              />
            </td>
          </tr>
          <tr>
            <td colSpan="3">
              <hr className="border-t-[1px] border-black mb-1" />
            </td>
          </tr>
          <tr>
            <td colSpan="3">
              <img id="imageId" className="w-44" />
            </td>
          </tr>
          <tr>
            <td colSpan="3" className="text-[14px]">
              <div className="font-semibold">
                {dataResult?.ConsultantRadiologist}
              </div>
              {dataResult?.ConsultantRadiologistDesignation && (
                <div>
                  {"(" + dataResult?.ConsultantRadiologistDesignation + ")"}
                </div>
              )}
              <div>{dataResult?.ESINo}</div>
              <div className="mb-2">Reg No: {dataResult?.RegNo}</div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}
